'use client';

import { c as _c } from "react/compiler-runtime";
import { SUBSCRIPTION, type Subscription } from '@algoacademy/backend/modules/marketplace/enums';
import { PAYMENT__PERMISSIONS } from '@algoacademy/backend/modules/payment/permissions';
import { cn } from '@algoacademy/design-system/shared/cn';
import { LightCard } from '@algoacademy/design-system/web/data-display/Card';
import { VerticalSpacer } from '@algoacademy/design-system/web/layouts/VerticalSpacer';
import { H2 } from '@algoacademy/design-system/web/marketing/typography/Heading/H2';
import { useState } from 'react';
import { useAuth } from '@/app/_auth/useAuth';
import { EMPTY_MENTORING_DISCOUNT, toMentoringDiscountInput } from './_components/DiscountControls';
import { MENTORING_TABS, MENTORING_TYPE_FILTER_OPTIONS, MentoringTabs } from './_components/MentoringTabs';
import { PricingCard } from './_components/PricingCard';
import { StaffMentoringOfferPanel } from './_components/StaffMentoringOfferPanel';
import { STAFF_MENTORING_PANEL_TAB, type StaffMentoringPanelTab, StaffMentoringPanelTabs } from './_components/StaffMentoringPanelTabs';
import { SubscriptionTabs } from './_components/SubscriptionTabs';
import { GroupMentoring } from './Mentoring/GroupMentoring';
import { IndividualMentoring } from './Mentoring/IndividualMentoring';
import { ProjectMentoring } from './Mentoring/ProjectMentoring';
import { useMentoringProducts } from './Mentoring/useMentoringProducts';
export function MentoringPricing(t0) {
  const $ = _c(58);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    defaultMentoringTab: t2,
    goalPage: t3,
    hideSectionHeading: t4
  } = t1;
  const defaultMentoringTab = t2 === undefined ? MENTORING_TABS.GROUP : t2;
  const goalPage = t3 === undefined ? false : t3;
  const hideSectionHeading = t4 === undefined ? false : t4;
  const {
    user
  } = useAuth();
  let t5;
  if ($[2] !== user) {
    t5 = user.hasPermissions([PAYMENT__PERMISSIONS.PAYMENTS.MANAGE.ENABLED]);
    $[2] = user;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const canManagePayments = t5;
  const [activeSubscriptionTab, setActiveSubscriptionTab] = useState(SUBSCRIPTION.PER_4_WEEKS);
  const [activeMentoringTab, setActiveMentoringTab] = useState(defaultMentoringTab);
  const [activeStaffPanelTab, setActiveStaffPanelTab] = useState(STAFF_MENTORING_PANEL_TAB.DETAILS);
  const [discountDraft, setDiscountDraft] = useState(EMPTY_MENTORING_DISCOUNT);
  const {
    individualProduct,
    setIndividualProduct,
    groupProduct,
    projectProduct
  } = useMentoringProducts(activeSubscriptionTab);
  const currentProduct = activeMentoringTab === MENTORING_TABS.INDIVIDUAL ? individualProduct : activeMentoringTab === MENTORING_TABS.PROJECT ? projectProduct : groupProduct;
  let t6;
  if ($[4] !== canManagePayments || $[5] !== discountDraft) {
    t6 = canManagePayments ? toMentoringDiscountInput(discountDraft) : null;
    $[4] = canManagePayments;
    $[5] = discountDraft;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const staffDiscount = t6;
  let t7;
  if ($[7] !== activeMentoringTab || $[8] !== activeSubscriptionTab || $[9] !== goalPage || $[10] !== individualProduct || $[11] !== setIndividualProduct) {
    t7 = activeMentoringTab === MENTORING_TABS.INDIVIDUAL ? <IndividualMentoring activeSubscriptionTab={activeSubscriptionTab} individualMentoringProduct={individualProduct} setIndividualMentoringProduct={setIndividualProduct} goalPage={goalPage} /> : activeMentoringTab === MENTORING_TABS.PROJECT ? <ProjectMentoring goalPage={goalPage} /> : <GroupMentoring goalPage={goalPage} />;
    $[7] = activeMentoringTab;
    $[8] = activeSubscriptionTab;
    $[9] = goalPage;
    $[10] = individualProduct;
    $[11] = setIndividualProduct;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const mentoringDetailsPanel = t7;
  const t8 = hideSectionHeading ? undefined : "mentoring-pricing-heading";
  const t9 = hideSectionHeading ? "Wybierz mentoring" : undefined;
  let t10;
  if ($[13] !== goalPage || $[14] !== hideSectionHeading) {
    t10 = !hideSectionHeading ? <H2 id="mentoring-pricing-heading" className={cn(goalPage && "text-white")}>{goalPage ? "Tw\xF3j mentoring" : "Wybierz mentoring idealny dla Ciebie"}</H2> : null;
    $[13] = goalPage;
    $[14] = hideSectionHeading;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== activeMentoringTab || $[17] !== goalPage || $[18] !== hideSectionHeading) {
    t11 = !goalPage ? <>{!hideSectionHeading ? <VerticalSpacer size="content" /> : null}<MentoringTabs tabs={Object.values(MENTORING_TYPE_FILTER_OPTIONS)} activeTab={activeMentoringTab} setActiveTab={setActiveMentoringTab} /></> : null;
    $[16] = activeMentoringTab;
    $[17] = goalPage;
    $[18] = hideSectionHeading;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11) {
    t12 = <div className="flex min-w-0 flex-col items-center text-center">{t10}{t11}</div>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <VerticalSpacer size="content" />;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== activeStaffPanelTab || $[25] !== canManagePayments || $[26] !== currentProduct || $[27] !== discountDraft || $[28] !== goalPage || $[29] !== mentoringDetailsPanel) {
    t14 = <div className="flex w-full min-w-0 flex-col gap-8">{canManagePayments ? <><StaffMentoringPanelTabs activeTab={activeStaffPanelTab} setActiveTab={setActiveStaffPanelTab} goalPage={goalPage} /><div className={cn(activeStaffPanelTab !== STAFF_MENTORING_PANEL_TAB.DETAILS && "hidden")}>{mentoringDetailsPanel}</div><div className={cn(activeStaffPanelTab !== STAFF_MENTORING_PANEL_TAB.OFFER && "hidden")}><StaffMentoringOfferPanel mentoringProduct={currentProduct} discountDraft={discountDraft} onDiscountChange={setDiscountDraft} goalPage={goalPage} /></div></> : mentoringDetailsPanel}</div>;
    $[24] = activeStaffPanelTab;
    $[25] = canManagePayments;
    $[26] = currentProduct;
    $[27] = discountDraft;
    $[28] = goalPage;
    $[29] = mentoringDetailsPanel;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  const t15 = goalPage && "dark";
  let t16;
  if ($[31] !== t15) {
    t16 = cn("top-8 block w-full shrink-0 self-start rounded-lg lg:sticky lg:w-sm", t15);
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      marginTop: "4.5rem"
    };
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <legend className="w-full text-contentSecondary text-sm leading-6 xl:text-base xl:leading-7">Typ subskrypcji</legend>;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = Object.values(SUBSCRIPTION);
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== activeSubscriptionTab || $[37] !== goalPage) {
    t20 = <fieldset className="m-0 max-w-full space-y-2 border-0 p-0 text-center">{t18}<SubscriptionTabs tabs={t19 as Subscription[]} activeTab={activeSubscriptionTab} setActiveTab={setActiveSubscriptionTab} goalPage={goalPage} /></fieldset>;
    $[36] = activeSubscriptionTab;
    $[37] = goalPage;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  const t21 = goalPage || !hideSectionHeading;
  let t22;
  if ($[39] !== currentProduct || $[40] !== goalPage || $[41] !== staffDiscount || $[42] !== t21) {
    t22 = <PricingCard mentoringProduct={currentProduct} goalPage={t21} pricingGoalPage={goalPage} discount={staffDiscount} />;
    $[39] = currentProduct;
    $[40] = goalPage;
    $[41] = staffDiscount;
    $[42] = t21;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== t20 || $[45] !== t22) {
    t23 = <div className="flex flex-col items-center gap-8">{t20}{t22}</div>;
    $[44] = t20;
    $[45] = t22;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t16 || $[48] !== t23) {
    t24 = <LightCard className={t16} style={t17}>{t23}</LightCard>;
    $[47] = t16;
    $[48] = t23;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t14 || $[51] !== t24) {
    t25 = <div className="relative flex flex-col gap-8 lg:flex-row lg:items-start">{t14}{t24}</div>;
    $[50] = t14;
    $[51] = t24;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t12 || $[54] !== t25 || $[55] !== t8 || $[56] !== t9) {
    t26 = <section id="wybierz-mentoring-idealny-dla-ciebie" aria-labelledby={t8} aria-label={t9}>{t12}{t13}{t25}</section>;
    $[53] = t12;
    $[54] = t25;
    $[55] = t8;
    $[56] = t9;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  return t26;
}